import React from "react";
import { Component } from "react";
import TotalSpend from "./total-spend.component";
import { LineChartData } from "./line-chart.component";
import { ChartHeaderDropdown } from "../../../common/data-header/chart-header-dropdown.component";
import Translation from '../../../common/translation/translation.component';

class UsageChart extends Component {
    render(){   
        const { usageChart, spendChart, firstLineColor, secondLineColor, thirdLineColor, forthLineColor,
                lineYAxis, graphHeader, graphFooter, dropdownValues, productDetails, selectedUsageMonth,
                onUsageMonthSelect, usageMonthOptions, usageSpendLineData, currencySymbol } = this.props;
        return (
           <div className="usage-main-container">          
                <ChartHeaderDropdown
                    haveOneIcone={false}
                    haveIconInfo={false}
                    iconInfo="info-circle-solid"
                    haveLedger={true}
                    usageHeaderName={<Translation translationKey="usageChart" />}
                    circleIcon={false}
                    circleFirstIcon="list-regular"
                    circleSecondIcon="th-solid"
                    oneIcon="vertical-grid"
                    haveInput={false}
                    haveDropdown={true}
                    dropdownItem={dropdownValues}
                    productDetails={productDetails}
                    usageChart={usageChart}
                    selectedUsageMonth={selectedUsageMonth}
                    onUsageMonthSelect={onUsageMonthSelect}
                    usageMonthOptions={usageMonthOptions}
                    isUsageChartTitle={true}
                />
                <TotalSpend
                    usageChart={usageChart}
                    spendChart={spendChart}
                    selectedUsageMonth={selectedUsageMonth}
                    currencySymbol={currencySymbol}
                />
                <h1 className="chart-title">{graphHeader}</h1>
                <LineChartData
                    toolTipEnable={true}
                    firstLineColor={firstLineColor}
                    secondLineColor={secondLineColor}
                    currencySymbol={currencySymbol}
                    thirdLineColor={thirdLineColor}
                    forthLineColor={forthLineColor}
                    lineYAxis={lineYAxis}
                    usageSpendLineData={usageSpendLineData}
                />
                {graphFooter!==undefined ?
                <div className="graph-footer">
                    {spendChart.map((item,id)=>
                        <h1 key={id} className="line-graph-footer">{item.Year}</h1>
                    )}
                </div> : "" }           
           </div>
        );
    }
}

export default UsageChart;
